import Rails from 'rails-ujs';

$(document).ready(function() {

  /* Mobile informations about order on product page */

  $('.mobile-sticky__toggle').hide();

  $('.mobile-slide-toggle__arrow').click(function(){
    var arrow = $(this).find('img');
    $('.mobile-sticky__toggle').slideToggle(function(){
      arrow.toggle();
    });
    return false;
  });

  $(document).on('change','.js-form-input, .js-form-select', function() {
    var thisForm = this;
    var link = $(this).data('url');
    var code = $(this).data('session');
    var product = $(this).data('product');
    if ($(this).is("select")) {
      var value = $(this).find('option:selected').text();
      $(this).closest('tr').find('.js-form-input').val(value);
    }
    else
    {
      var value = $(this).val();
      $(this).closest('tr').find('.js-form-select option').prop('selected', false);
      $(this).closest('tr').find('.js-form-select option:eq('+value+')').prop('selected', true);
    }


    $.ajax({
        url: link,
        type: 'POST',
        dataType: 'json',
        data: {
          session_product: {
            student_code: code,
            product_id: product,
            quantity: value
          }

        },
        success: function (response, statusText, xhr) {
          if (value == 0)
          {
             $(thisForm).closest('tr').remove();
          }
          var products = $('.order__recap-row').find('tr:visible');
          var total = 0;
          var total_qty = 0;
          for (var i = products.length - 1; i >= 0; i--) {
            price = parseFloat($(products[i]).find('.order__recap-price').text());
            quantity = $(products[i]).find('.order__recap-quantity .js-form-input').val();
            total = total + (price *  quantity);
            total_qty = total_qty + (1 * quantity);

          }
          $('.nav__number-item').text(total_qty);
          $('.order__total-products-text span').text(total_qty);
          $('.order__total').text('Total : '+ total.toFixed(2) + ' €');
          $('.paragraph-price').text(total.toFixed(2));
          $('.mobile__nav-number-item').text(total_qty);
        },
        error: function (response, statusText, xhr) {
            alert(statusText);
        }
    });
  })

  $('.js-order-change').on('change', function(e) {

    var form = $(this).closest('form');
    var link = form.attr('action');
    var data = form.serialize();
    Rails.ajax({
        url: link,
        type: 'POST',
        data: data,
        success: function (response, statusText, xhr) {
          $('.mobile__nav-shopping-cart-preview-block').html(
            // replace with the returned one from the AJAX response.
            $(response).find('.mobile__nav-shopping-cart-preview-block').html()
          );
          $('.nav__shopping-cart-preview-block').html(
            // replace with the returned one from the AJAX response.
            $(response).find('.nav__shopping-cart-preview-block').html()
          );
        },
        error: function (response, statusText, xhr) {
            alert(statusText);
        }
    });

  });

  $('.js-empty-basket').on('click', function(e) {
    e.preventDefault();
    var link = $(this).attr('href');
    $.ajax({
        url: link,
        type: 'GET',
        dataType: 'json',
        success: function (response, statusText, xhr) {
          $('.order__list, .order__empty-basket-text, .order__total, .order__bottom-page').remove();
          $( ".order__table" ).append( "<p class='order__text'>Vous n'avez encore rien ajouté à votre commande</p>" );
          $('.nav__number-item').text("0");
          $('.paragraph-price').text("0");
          $('.order__total-products-text span').text('0');
          $('.mobile__nav-number-item').text("0");
          window.location.href = "/";
        },
        error: function (response, statusText, xhr) {
            alert(statusText);
        }
    });
  });

  $(document).on('click', '.js-finalize', function() {
    $(this).closest('form').submit();
  });

  /* Pop-in on product page */

  $('.js-pop-in-close').on('click', function(){
    $('.pop-in__overlay').hide();
  });

  /* Preview on every product using drift zoom library on desktop and tablet */

  $('.js-product-preview').each(function(){

    var image = $(this).find('.js-product-preview-image').get(0);
    if (image) {
      var preview = $(this).find('.js-product-preview-hover').get(0);

      new Drift(
        image, {
        paneContainer: preview,
        inlinePane: false,
        hoverBoundingBox: true,
        handleTouch: false,
        boudingBoxContainer: $(image).parent().get(0),
        onShow: function() {
          $(preview).show();
        },
        onHide: function() {
          $(preview).hide();
        }
      });
    }
  });
});
